import { UPDATE_SALE } from '../constants/ActionTypes';
import clearReservation from './clearReservation';
import reserve from './reserve';
import clearReservations from './clearReservations';

function updateSaleSuccess(sale, saleValues) {
  return {
    type: UPDATE_SALE,
    sale,
    saleValues
  };
}

export default function updateSale(newSale) {
  return (dispatch, getState) => {
    const oldSale = getState().sale.sale;
    const potentialSale = Object.assign({}, oldSale, newSale);

    if (oldSale.id != null) {
      if (oldSale.day != potentialSale.day) {
        dispatch(clearReservations());
      } else {
        const oldPackages = oldSale.packages || {};
        const potentialPackages = potentialSale.packages || {};
        const oldReserved = oldSale.reservedPackages || {};

        var removedRes = Object.keys(oldReserved)
          .filter(pkgId => {
            return potentialPackages[pkgId] == null;
          })
          .map(pkgId => {
            return {
              resId: oldReserved[pkgId]['itmres_no'],
              pkgId: pkgId
            };
          });

        var updatedRes = Object.keys(oldReserved)
          .filter(pkgId => {
            return (
              oldPackages[pkgId] != null &&
              potentialPackages[pkgId] != null &&
              oldPackages[pkgId].qty > 0 &&
              potentialPackages[pkgId].qty != oldPackages[pkgId].qty
            );
          })
          .map(pkgId => {
            return {
              resId: oldReserved[pkgId]['itmres_no'],
              pkgId: pkgId
            };
          });

        removedRes.forEach(res =>
          dispatch(clearReservation(res.resId, res.pkgId))
        );
        Promise.all(
          updatedRes.map(res =>
            dispatch(clearReservation(res.resId, res.pkgId))
          )
        ).then(() => {
          dispatch(reserve());
        });
      }
    }

    return dispatch(updateSaleSuccess(potentialSale, newSale));
  };
}
